// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","divider":"Footer_divider__h4mYW"};